import { Users, CreditCard } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Link } from 'react-router-dom';
import { Button } from './ui/button';
import { ArrowRight } from 'lucide-react';
import { Reveal } from './Reveal';

const audiences = [
  {
    icon: Users,
    title: 'Providers & ACOs',
    description: 'Sharper decisions and less administrative drag mean catching HCC/RAF gaps and attribution drift before revenue leaks, with shared-savings risk surfaced while there\'s still time to act.',
    iconBg: 'bg-[#34AFFB]/10',
    iconColor: 'text-[#34AFFB]',
    href: '/who-we-serve/providers-and-acos',
    cta: 'For Providers & ACOs',
  },
  {
    icon: CreditCard,
    title: 'Payers & Health Plans',
    description: 'Quality, risk-adjustment, and cost insight that improves Stars, protects shared savings, and reduces MLR, with clinical context kept alongside the financial signal.',
    iconBg: 'bg-[#70D6C5]/10',
    iconColor: 'text-[#70D6C5]',
    href: '/who-we-serve/payers',
    cta: 'For Payers & Health Plans',
  },
];

export function WhoWeServe() {
  return (
    <section id="who-we-serve" className="py-20 bg-[#f9fbfc]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal className="text-center mb-16">
          <span className="border-l-4 border-[#34AFFB] pl-3 text-[#34AFFB] text-sm font-semibold">
            Who We Help
          </span>
          <h2 className="mt-6 text-4xl text-[#1f2937]">
            Built for the organizations carrying risk.
          </h2>
          <p className="mt-4 text-xl text-[#4B5563] max-w-3xl mx-auto">
            Care that becomes more proactive, coherent, and whole.
          </p>
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto">
          {audiences.map((audience, index) => {
            const Icon = audience.icon;
            return (
              <Reveal as="div" key={index} delay={index * 140} className="h-full">
              <Card className="border-none shadow-sm hover:shadow-md transition-shadow flex flex-col h-full">
                <CardHeader>
                  <div className={`${audience.iconBg} w-12 h-12 rounded-lg flex items-center justify-center mb-4`}>
                    <Icon className={`w-6 h-6 ${audience.iconColor}`} />
                  </div>
                  <CardTitle>{audience.title}</CardTitle>
                </CardHeader>
                <CardContent className="flex flex-col flex-1 justify-between gap-6">
                  <p className="text-[#4B5563]">{audience.description}</p>
                  <Button asChild variant="ghost" className="self-start p-0 h-auto text-[#34AFFB] hover:text-[#34AFFB]/80 hover:bg-transparent font-medium">
                    <Link to={audience.href}>
                      {audience.cta}
                      <ArrowRight className="ml-1 h-4 w-4" />
                    </Link>
                  </Button>
                </CardContent>
              </Card>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
